import Flickity from 'flickity';

export function ProductGallery(element) {
	if (!element) {
		return;
	}

	let currentIndex = 0;

	const primaryElement = element.querySelector('.js-product-gallery-primary');

	if (!primaryElement) {
		return;
	}

	const carousel = new Flickity(primaryElement, {
		cellAlign: 'left',
		contain: true,
		initialIndex: currentIndex,
		lazyLoad: true,
		prevNextButtons: true,
		arrowShape: {
			x0: 10,
			x1: 70,
			y1: 40,
			x2: 70,
			y2: 40,
			x3: 70,
		},
	});

	function selectByVariant(name) {
		let index = carousel.cells.findIndex(cell => {
			return cell.element.dataset.variant.includes(name);
		});

		if (index === -1) {
			return false;
		}

		carousel.select(index, true, true);

		return true;
	}

	return { selectByVariant };
}
